import { DataRouteDefinition, ExtractFetcherDataType } from "routes/data-routes/types";
import { Coupon, CouponError } from "types/Coupons";


export const CheckCouponsDataRoutePath = "/data-routes/billing-data/coupons/check";

export type CheckCouponsDataRouteType = DataRouteDefinition<Coupon | CouponError, "coupon", typeof CheckCouponsDataRoutePath>;

// used by some fetchers inside various components
export type CheckCouponsFetcherDataType = ExtractFetcherDataType<ReturnType<NonNullable<CheckCouponsDataRouteType["useCoupon"]>>>;
